import { AreYouDoneIcon } from '@trufla-technology/trumarket-react-design-system';

interface IProps {
  isVerified: boolean;
  error: boolean;
  isLoading: boolean;
}

function DeploymentDetails({ isVerified, error, isLoading }: IProps) {
  return (
    <div className="deployment-details">
      <div className="deployment-content">
        {isVerified ? (
          <>
            <h4 className="success-done">You are Done</h4>
            <p>
              Your Initial Setup Is Finished You Will Need to Continue on
              WP-Engine <a href="https://my.wpengine.com/">here</a>
            </p>
            <p className="extra-content">
              Use the following credentials to login
            </p>
            <div className="you-are-done">
              <AreYouDoneIcon width="90" />
            </div>
          </>
        ) : (
          <>
            <h4>You are almost done</h4>
            <p>
              Use the following credentials to login to each environment on
              WP-Engine, then click Verify.
            </p>
            {!isLoading && (
              <>
                {error && (
                  <div className="environment-error-msg">
                    Something went wrong, please try again!
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default DeploymentDetails;
